export default defineNuxtRouteMiddleware(async (to, from) => {
  const precompiled = {
    orderID: "orderID",
    Nome: "name",
    Cognome: "surname",
    CF: "tax_code",
    Iban: "iban",
  };

  if (langs.includes(to.params.step as string)) {
    updateStateValue("lang", to.params.step);

    if (to.params.code) {
      const code = to.params.code as string;
      const data = await (
        useNuxtApp().$loadPrecompiledData as (code: string) => Promise<any>
      )(code);

      if (!data) {
        return;
      }

      updateStateValue("protected", false);
      updateStateValue("preCompiled", true);

      Object.keys(data as any).forEach((key) => {
        const stateKey = precompiled[key as keyof typeof precompiled];
        if (stateKey) {
          updateStateValue(stateKey, data[key as keyof typeof data]);
        }
      });
    }
  }
});
